const docEnum = [
  {value:'driving_permit', label:'Водительское удостоверение'},
  {value:'snils', label:'СНИЛС'},
]
export default docEnum;